<template>
    <div>
        <form @submit.prevent="submit" ref="addItem">
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-input
                    grid="6"
                    v-model="nome"
                    label="Nome"
                    :required="true"
                />
                <form-select
                    grid="6"
                    v-model="fonte"
                    label="Fonte do Recurso orçamentário"
                    :itens="$root.arrays.beneficio_fonte"
                    :required="true"
                />
                <form-select
                    grid="4"
                    v-model="tipo"
                    label="Tipo"
                    :itens="tipos"
                    :required="true"
                    @input="getSubTipos"
                />
                <form-select
                    grid="4"
                    :disabled="subtipos.length == 0 ? true : false"
                    v-model="subtipo"
                    label="Subtipo"
                    :itens="subtipos"
                />
                <form-input grid="4" v-model="quantidade" label="Quantidade" type="number" min="0"/>

                <form-calendar-range
                    grid="4"
                    v-model="periodo"
                    label="Período Inicial e Final"
                />
                <form-input
                    grid="4"
                    v-model="idade_minima"
                    label="Idade Mínima"
                    type="number"
                    min="0"
                />
                <form-input
                    grid="4"
                    v-model="idade_maxima"
                    label="Idade Máxima"
                    type="number"
                    min="0"
                />
                <form-select
                    grid="4"
                    v-model="sexo"
                    label="Sexo"
                    :itens="$root.arrays.beneficio_sexo"
                />
                <form-select
                    grid="4"
                    v-model="categoria"
                    label="Categoria"
                    :itens="$root.arrays.beneficio_categoria"
                    :required="true"
                />
                <form-input grid="4" v-model="valor" label="Valor R$" v-show="mostrarValor" @input="formatarValor"/>
                <form-select
                    grid="4"
                    v-model="status"
                    label="Status"
                    :itens="status_beneficio"
                    :required="true"
                />
                <form-select
                    grid="8"
                    v-model="unidade"
                    label="Unidade"
                    :itens="unidades"
                    :required="true"
                    :multiple="true"
                />
                <form-textarea v-model="descricao" label="Observação" />
                <form-toggle
                    grid="12"
                    mt="0"
                    v-model="is_itens"
                    label="Possui Itens?"
                />
            </div>
            <div v-if="is_itens == 1">
                <div v-for="i in count" :key="i">
                    <div class="row px-md-2">
                        <form-input
                            grid="3"
                            class="px-md-1"
                            v-model="item_nome[i]"
                            label="Nome"
                            :required="true"
                        />
                        <form-input
                            grid="2"
                            class="px-md-1"
                            v-model="item_quantidade[i]"
                            label="Qtd"
                            :required="true"
                            type="number"
                            min="1"
                        />
                        <form-input
                            grid="2"
                            class="px-md-1"
                            v-model="item_dimensoes[i]"
                            label="Dimensão"
                        />
                        <form-input
                            grid="2"
                            class="px-md-1"
                            v-model="item_peso[i]"
                            label="Peso"
                        />
                        <form-calendar
                            grid="2"
                            class="px-md-1"
                            v-model="item_validade[i]"
                            label="Validade"
                        />
                        <div
                            class="col-sm-12 col-md-1 px-md-1"
                            v-if="i < count"
                        >
                            <a
                                class="col btn btn-danger btn-sm mt-4"
                                @click="excluirItem(i)"
                            >
                                <i class="col mdi mdi-close px-0"></i>
                            </a>
                        </div>
                        <div v-else class="col-sm-12 col-md-1 px-md-1">
                            <a
                                class="col btn btn-success btn-sm mt-4"
                                @click="count++"
                            >
                                <i class="col mdi mdi-plus px-0"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: "Add",
    data() {
        return {
            tipo: "",
            subtipo: "",
            nome: "",
            quantidade: "",
            fonte: "",
            idade_minima: "",
            idade_maxima: "",
            periodo: "",
            sexo: "",
            categoria: "",
            valor: "",
            status: "",
            unidade: "",
            descricao: "",
            is_itens: 0,
            item_nome: [],
            item_quantidade: [],
            item_dimensoes: [],
            item_peso: [],
            item_validade: [],
            count: 1,
            tipos: [],
            subtipos: [],
            status_beneficio: [],
            unidades: [],
            loadSubtipo: true,
        };
    },
    mounted() {
        this.getTipos();
        this.getStatus();
        this.getUnidades();
    },
    watch:{
		'categoria'(novaCategoria) {

			this.mostrarValor = novaCategoria === 1;

			if (novaCategoria !== 1) {
				this.valor = null;
			}

		}
	},
    methods: {
        excluirItem(item) {
            this.count--;
            this.item_nome.splice(item, 1);
            this.item_quantidade.splice(item, 1);
            this.item_dimensoes.splice(item, 1);
            this.item_peso.splice(item, 1);
            this.item_validade.splice(item, 1);
        },
        formatarValor() {

			// Remove tudo o que não for número
			let valor = this.valor.replace(/\D/g, '');

			// Adiciona o ponto de milhar e formata com a vírgula para centavos
			if (valor.length > 2) {
			valor = valor.replace(/(\d)(\d{2})$/, '$1,$2');
			}
			if (valor.length > 6) {
			valor = valor.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');
			}

			// Atualiza o valor formatado no v-model
			this.valor = valor;

		},
		carregarValorDoBanco(valor) {

			// Verifica se o valor já tem separador decimal
			let formattedValue = valor.toString().trim();

			if (formattedValue.includes(',') || formattedValue.includes('.')) {

				// Se já tiver separador decimal, aplica a formatação de número com vírgula
				formattedValue = formattedValue.replace(/\D/g, '');
				
				if (formattedValue.length > 2) {

					formattedValue = formattedValue.replace(/(\d)(\d{2})$/, '$1,$2');

				}

				if (formattedValue.length > 6) {

					formattedValue = formattedValue.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');

				}

			}else{

				// Caso não tenha separador de casas decimais, adicionamos ,00
				formattedValue = formattedValue.replace(/\D/g, '') + ',00';

			}

			return formattedValue;

		},
		// Função para limpar a formatação e enviar apenas o valor numérico
		formatarParaSubmit(valorFormatado) {

			// Remove todos os caracteres que não são números ou vírgula
			let valorLimpo = valorFormatado.replace(',', '.');

			return valorLimpo;

		},
        getTipos() {
            axios.get(`api/dashboard/get/beneficios/tipos`).then((response) => {
                this.tipos = response.data;
            });
        },
        getSubTipos() {
            this.loadSubtipo = true;
            this.subtipos = [];
            axios
                .get(`api/dashboard/get/beneficios/subtipos/${this.tipo}`)
                .then((response) => {
                    this.subtipos = response.data;
                })
                .finally(() => {
                    this.loadSubtipo = false;
                });
        },
        getStatus() {
            axios
                .get(`api/dashboard/get/beneficios/status`)
                .then((response) => {
                    this.status_beneficio = response.data;
                });
        },
        getUnidades() {
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                });
        },
        submit() {
            if (this.is_itens == 0) {
                this.item_nome = [];
                this.item_quantidade = [];
                this.item_dimensoes = [];
                this.item_peso = [];
                this.item_validade = [];
            }
            let itens = {
                nome: this.item_nome,
                quantidade: this.item_quantidade,
                dimensoes: this.item_dimensoes,
                peso: this.item_peso,
                validade: this.item_validade,
            };
            // if (this.periodo) {
            //   this.periodo["start"] = moment(
            //     this.periodo["start"],
            //     "YYYY-MM-DD"
            //   ).format("DD/MM/YYYY");
            //   this.periodo["end"] = moment(this.periodo["end"], "YYYY-MM-DD").format(
            //     "DD/MM/YYYY"
            //   );
            // }

            if (this.categoria != 2) {

                // Antes de enviar para o banco, formatamos o valor corretamente
                let valorParaEnviar = this.formatarParaSubmit(this.valor);

                // Agora, atualizamos o valor no objeto 'beneficio'
                this.valor = valorParaEnviar;

            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/beneficio`, {
                    tipo_id: this.tipo,
                    subtipo_id: this.subtipo,
                    nome: this.nome,
                    quantidade: this.quantidade,
                    fonte_recurso: this.fonte,
                    idade_minima: this.idade_minima,
                    idade_maxima: this.idade_maxima,
                    periodo: this.periodo,
                    sexo: this.sexo,
                    categoria: this.categoria,
                    valor: this.valor,
                    status: this.status,
                    unidades: this.unidade,
                    descricao: this.descricao,
                    itens: itens,
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    if (this.morph != undefined) {
                        this.$emit("reload");
                    } else {
                        this.$router.push(
                            `/dashboard/beneficio/edit/${response.data.data.id}`
                        );
                    }
                })
                .finally(() => {
                    this.files = [];
                });
        },
    },
};
</script>
